// orderStatusMaster.ts
export const ORDER_DETAIL_BUTTON = [
    {
        key: "HISTORY",
        label: "Order History",
        sequence: 1,
        icon: "shopping-bag",
    },
    {
        key: "ORDER-DETAIL",
        label: "Order Details",
        sequence: 2,
        icon: "shopping-bag",
    },
    {
        key: "CUSTOMER-DETAIL",
        label: "Customer Detail",
        sequence: 3,
        icon: "shopping-bag",
    },
];
